import { ArrowLeftOutlined } from "@ant-design/icons";
import { DatePicker, Modal } from "antd";
import dayjs from "dayjs";
import { UiTable, UiProfileModel, UiRangePicker, UiButton } from "../../../../components";
import { tablePageSizeOptions } from "../../../../utils/appUtils";
import GenerateCouponDrawer from "../couponDrawer/generateCouponDrawer";
import closeIcon from "../../../../assets/images/close.svg";
import { userIcon } from "../../../../assets/images";
import "./style.scss";

const CouponsHistory = ({
    customerData,
    couponsData,
    totalElements,
    stats,
    filter,
    setFilter,
    columns,
    onBack,
    onPagination,
    onAddCoupon,
    drawerOpen,
    formData,
    onDrawerClose,
    onInputChange,
    onSubmit,
    deleteModalOpen,
    onDeleteConfirm,
    onDeleteCancel,
    isEditMode
}) => {

    return (
        <div className="coupons-history-container">
            <div className="flexible" style={{ alignItems: "center" }}>
                <div className="flexible">
                    <div className="history-header">
                    <ArrowLeftOutlined onClick={onBack} className="back-icon" />
                    <h6 style={{ padding: "10px", margin: 0, whiteSpace: "nowrap" }}>Coupons History</h6>
                </div>
                </div>
                <div className="button-group" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    <DatePicker
                        picker="month"
                        format="MMM"
                        placeholder="Select Month"
                        value={filter?.month}
                        onChange={(date) => setFilter(prev => ({ ...prev, month: date, startDate: null, endDate: null, page: 0 }))}
                        disabledDate={(current) => current && current > dayjs().endOf("day")}
                        style={{ height: 32, width: 150, borderRadius: 6 }}
                    />
                    <UiRangePicker
                        placeholder={["Start date", "End date"]}
                        value={filter?.startDate && filter?.endDate ? [dayjs(filter?.startDate), dayjs(filter?.endDate)] : null}
                        onChange={(dates) => setFilter(prev => ({ ...prev, startDate: dates?.[0] || null, endDate: dates?.[1] || null, month: null, page: 0 }))}
                        disabledDate={(current) => current && current > dayjs().endOf("day")}
                        style={{ width: '250px' }}
                    />
                    <UiButton
                        className="offers-send-btn"
                        onClick={onAddCoupon}
                    >
                        + Add Coupon
                    </UiButton>
                </div>
            </div>
            <div className="customer-info-section">
                <div className="customer-profile">
                    <div style={{ marginRight: "16px" }}>
                        {
                            !customerData?.profileImage || customerData?.profileImage?.includes("null") || customerData?.profileImage?.includes("undefined") ?
                                <img src={userIcon} style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover" }} alt="" /> :
                                <UiProfileModel imageUrl={customerData?.profileImage} />
                        }
                    </div>
                    <div className="customer-details">
                        <h3 className="customer-name">{customerData?.customerName || "Nil"}</h3>
                        <p className="customer-id">ID: {customerData?.customerNo || "Nil"}</p>
                    </div>
                </div>
                <div className="coupon-stats">
                    <div className="stat-item">
                        <label>Total Coupons</label>
                        <span className="stat-value">{String(stats?.total || 0).padStart(2, '0')}</span>
                    </div>
                    <div className="stat-item">
                        <label>Used Coupons</label>
                        <span className="stat-value">{String(stats?.used || 0).padStart(2, '0')}</span>
                    </div>
                    <div className="stat-item">
                        <label>Unused Coupons</label>
                        <span className="stat-value">{String(stats?.unused || 0).padStart(2, '0')}</span>
                    </div>
                </div>
            </div>
            <div className="coupons-history-table">
                <UiTable
                    columns={columns}
                    dataSource={couponsData}
                    scroll={{ x: "max-content" }}
                    pagination={{
                        current: filter?.page + 1,
                        pageSize: filter?.size,
                        total: totalElements,
                        onChange: onPagination,
                        showSizeChanger: true,
                        pageSizeOptions: tablePageSizeOptions,
                    }}
                    rowKey={(record, index) => index}
                />
            </div>
            <GenerateCouponDrawer
                open={drawerOpen}
                customerData={customerData}
                formData={formData}
                onClose={onDrawerClose}
                onInputChange={onInputChange}
                onSubmit={onSubmit}
                isEditMode={isEditMode}
            />
            <Modal
                title={null}
                open={deleteModalOpen}
                onCancel={onDeleteCancel}
                footer={null}
                centered
                width={400}
                className="delete-confirmation-modal"
            >
                <div style={{ textAlign: "center", padding: "15px" }}>
                    <img src={closeIcon} alt="close-icon" style={{ width: 50, height: 50, marginBottom: 10 }} />
                    <h6>Are you sure delete this coupon?</h6>
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "20px" }}>
                        <UiButton onClick={onDeleteCancel} style={{ background: "white", color: "#Cfa14e", border: "1px solid #Cfa14e" }}>Cancel</UiButton>
                        <UiButton  onClick={onDeleteConfirm} style={{ background: "#Cfa14e", color: "white" }}>Confirm</UiButton>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default CouponsHistory;
